import { purchaseOrderItems } from "@/api/purchaseOrderItems/usePurchaseOrderItems";
import { LeftSpace } from "@/features/location/detail/LocationDetailForm";
import { useModal } from "@/features/modal/ModalStackManager";
import { DetailContainer } from "@/features/standard/detail/Container";
import { DetailContent } from "@/features/standard/detail/Content";
import { DetailWrapper } from "@/features/standard/detail/Wrapper";
import { Main } from "@/features/standard/Main";
import { Tabs, Text, Title } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { DeliveredForm } from "../delivered/DeliveredForm";
import { ProductionPlanForm } from "../productionPlan/ProductionPlanForm";
import { StockPlanForm } from "../stockPlan/StockPlanForm";
import { PurchaseOrderItemDetailInForm } from "./PurchaseOrderItemDetailInForm";

const Detail = Object.assign(Main, {
  Container: DetailContainer,
  Wrapper: DetailWrapper,
  Content: DetailContent,
});
interface PurchaseOrderItemsDetailFormProps {
  purchaseOrderItemId: number;
  pageKey: "purchaseOrderItems" | "orderItems";
}
export const PurchaseOrderItemsDetailForm = (params: PurchaseOrderItemsDetailFormProps) => {
  const { purchaseOrderItemId, pageKey } = params;
  const { t } = useTranslation();
  const { openModal } = useModal();
  const { data } = useQuery(
    purchaseOrderItems.detail({
      purchaseOrderItemId: purchaseOrderItemId,
      populate: ["itemName", "purchaseOrder", "quantities", "partner"],
    }),
  );

  return (
    <>
      <Detail.Container>
        <Detail.Wrapper>
          <Detail.Content>
            <PurchaseOrderItemDetailInForm data={data?.data} pageKey={pageKey} />
            <Tabs defaultValue="productionPlan">
              <LeftSpace />
              <Tabs.List>
                <Tabs.Tab value="productionPlan">{t("productionPlan.productionPlan")}</Tabs.Tab>
                <Tabs.Tab value="stockPlanHistory">{t("stockPlan.stockPlan")}</Tabs.Tab>
                <Tabs.Tab value="deliveryHistory">{t("delivery.deliveryStatus")}</Tabs.Tab>
              </Tabs.List>
              <Tabs.Panel value="productionPlan" p={20}>
                <Title order={3}>생산 계획 정보</Title>
                <Text>관련된 생산 계획 정보를 보여줍니다.</Text>
                <ProductionPlanForm purchaseOrderItemID={purchaseOrderItemId} />
              </Tabs.Panel>
              <Tabs.Panel value="stockPlanHistory" p={20}>
                <Title order={3}>재고 계획 정보</Title>
                <Text>관련된 재고 계획 정보를 보여줍니다.</Text>
                <StockPlanForm purchaseOrderItemID={purchaseOrderItemId} />
              </Tabs.Panel>
              <Tabs.Panel value="deliveryHistory" p={20}>
                <Title order={3}>납품 이력 정보</Title>
                <Text>관련된 납품 이력 정보를 보여줍니다.</Text>
                <DeliveredForm purchaseOrderItemID={purchaseOrderItemId} />
              </Tabs.Panel>
            </Tabs>
          </Detail.Content>
        </Detail.Wrapper>
      </Detail.Container>
    </>
  );
};
